import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import * as mainActions from "../../actions/mainActions";
import { connect } from "react-redux";
import {
    Typography,
    Grid,
    TableRow,
    TableBody,
    Table,
    TableCell,
    TableHead,
    Button,
    Icon,
    Card,
    LinearProgress
} from "material-ui";
import jsPDF from "jspdf";
import moment from "moment";
import icon_excel from "../../resources/images/icon_excel.png";
import icon_pdf from "../../resources/images/icon_pdf.png";
import DatePickerCustom from "../displayComponents/DatePickerCustom";
import { toast } from "react-toastify";
import SelectComponent from "../displayComponents/SelectComponent";
import { validateDatesFilter, getFilterText, setHeader, setGraphic, setTable, setFooter } from "../../utils/utils";
import SimpleBarChart from "../chartComponents/SimpleBarChart";
import ReactExport from "react-data-export";
import { loadData } from "../../controllers/Dashboard";
import ExcelColumn from "react-data-export/dist/ExcelPlugin/elements/ExcelColumn";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class DashBoardContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            downloading: false,
            title: "Gráfica de distribución de persoas por país de procedencia",
            filename: "informe_diario_" + moment().format("DD-MM-YYYY"),
            data: [
                {
                    key: "country",
                    idKey: "origin",
                    labelName: "country_name",
                    data: [],
                    total: 0,
                    graphicVertical: true,
                    title: "Gráfica de distribución de persoas por país de procedencia"
                },
                {
                    key: "state",
                    idKey: "state_id",
                    labelName: "state_name",
                    data: [],
                    total: 0,
                    graphicVertical: true,
                    title: "Gráfica de distribución de persoas por comunidade"
                },
                {
                    key: "province",
                    idKey: "province_id",
                    labelName: "province_name",
                    data: [],
                    total: 0,
                    graphicVertical: true,
                    title: "Gráfica de distribución de persoas por provincia"
                },
                {
                    key: "municipality",
                    idKey: "municipality_id",
                    labelName: "municipality_name",
                    data: [],
                    total: 0,
                    graphicVertical: false,
                    title: "Gráfica de distribución de persoas por localidade"
                }
            ],
            excellData: [],
            filter: {
                from: moment()
                    .subtract(3, "month")
                    .format("DD/MM/YYYY 00:00"),
                to: moment().format("DD/MM/YYYY 23:59"),
                office: -1,
                municipality: -1
            }
        };
    }

    componentDidMount() {
        const { sessionData } = this.props.main;
        if (sessionData.municipality){
            this.setState({ filter: { ...this.state.filter,  municipality: sessionData.municipality} }, async ()=>{
                this.loadData();
            })
        } else{
            this.loadData();
        }
        
    }

    loadData = async () => {
        const { sessionData } = this.props.main;
        let { data, filter } = this.state;
        data = await loadData(data, sessionData, filter);
        this.setState(data);
        this.setState({ loading: false });
    };

    updateFilter = (value, name) => {
        if (
            !validateDatesFilter(this.state.filter.from, this.state.filter.to, {
                value: value,
                name: name
            })
        ) {
            toast("A data elexida no é válida", {
                className: "toast-error",
                autoClose: 2000
            });
        } else {
            let filter = {};
            filter[name] = value;
            if (name === 'municipality') filter.office = -1;
            this.setState({ filter: { ...this.state.filter, ...filter } }, this.loadData);
        }
    };

    setLogoutAlert = open => {
        this.setState({ open: open });
    };

    exportPdf = async () => {
        this.setState({ downloading: true });
        const { offices, municipalities } = this.props.main;
        try {
            const { data } = this.state;
            let doc = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                format: "a4"
            });
            for (let i = 0; i < data.length; i++) {
                let filter_text = getFilterText(this.state.filter, municipalities, offices);
                setHeader(doc, data[i].title, `Período: ${this.state.filter.from} a ${this.state.filter.to} ${filter_text}`);
                await setGraphic(doc, `graphic_${data[i].key}`);
                await setTable(doc, `table_${data[i].key}`);
                setFooter(doc, (i + 1), data.length);
                
                if (i + 1 < data.length) doc.addPage();
            }
            doc.save(this.state.filename);
        } catch (err) {
            console.error(err);
        }
        this.setState({ downloading: false });

    };

    setVertical = () => {
        let vertical;
        if (this.state.vertical === true) vertical = false;
        else vertical = true;
        this.setState({ vertical: vertical });
    };

    render() {
        const {
            data,
            filter: { from, to, office, municipality },
            filename,
            excellData,
            loading,
            downloading
        } = this.state;
        const { offices, municipalities, sessionData } = this.props.main;
        let buildData;
        if (data){
            buildData = data.map(section => {
                return {
                    ...section,
                    data: section.data.sort((a,b) => (a.personas > b.personas) ? -1 : ((b.personas > a.personas) ? 1 : 0))
                }
            })
        }
        return (
            <Fragment>
                <Grid item xs={12}>
                    <Card elevation={0} style={{ padding: '0.5em 1em' }}>
                        <Grid container spacing={16}>
                            <Grid item xs={4}>
                                <div style={{ flexDirection: 'column' }}>
                                    <DatePickerCustom
                                        label="Dende"
                                        value={from}
                                        format="DD/MM/YYYY"
                                        displayFormat="LL"
                                        setDate={moment => {
                                            this.updateFilter(moment.format("DD/MM/YYYY HH:mm"), "from");
                                        }}
                                    />
                                    <DatePickerCustom
                                        label="Ata"
                                        value={to}
                                        format="DD/MM/YYYY"
                                        displayFormat="LL"
                                        setDate={moment => {
                                            this.updateFilter(moment.format("DD/MM/YYYY HH:mm"), "to");
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <SelectComponent
                                    disabled={!!sessionData.municipality}
                                    label="Concello"
                                    defaultValue="Todos"
                                    items={municipalities}
                                    value={municipality}
                                    fieldValue="id"
                                    fieldName="name"
                                    setValue={event => {
                                        this.updateFilter(event.target.value, "municipality");
                                    }} />
                                <SelectComponent
                                    label="Oficina"
                                    defaultValue="Todas"
                                    items={(!!municipality && municipality != -1) ? offices.filter((office) => { return office.municipality_id === municipality }) : offices}
                                    value={office}
                                    fieldValue="id"
                                    fieldName="name"
                                    setValue={event => {
                                        this.updateFilter(event.target.value, "office");
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <div style={{ flexDirection: 'row', marginRight: '-1em' }}>
                                    <Button disabled={downloading} style={{
                                            backgroundColor: "#DDD",
                                            marginTop: '0.5em',
                                            float: 'right',
                                            marginRight: '1em'
                                        }} onClick={this.exportPdf}>
                                            Exportar gráficas en pdf
                                            <Icon style={{
                                                marginLeft: "0.8rem",
                                                color: "#f53838"
                                            }}>
                                                <img src={icon_pdf} alt="Exportar como pdf" />
                                            </Icon>
                                    </Button>
                                    <ExcelFile
                                        filename={filename}
                                        element={
                                            <Button style={{
                                                backgroundColor: "#DDD",
                                                marginTop: '0.5em',
                                                float: 'right',
                                                marginRight: '1em'
                                            }}>
                                                Exportar excel
                                                <Icon>
                                                    <img src={icon_excel} alt="Exportar como excel" />
                                                </Icon>
                                            </Button>
                                        }>
                                        {excellData.map(item => {
                                            return (
                                                <ExcelSheet
                                                    key={item.key}
                                                    data={item.data}
                                                    name={item.columns[0].label}>
                                                    {item.columns.map(column => {
                                                        return (
                                                            <ExcelColumn
                                                                key={`${item.key}_${column.value}`}
                                                                label={column.label}
                                                                value={column.value}
                                                            />
                                                        );
                                                    })}
                                                </ExcelSheet>
                                            );
                                        })}
                                    </ExcelFile>
                                    
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
                {loading ?
                    <Card style={{ width: '100%' }}>
                        <Typography variant="headline" component="h4">Cargando visitas...{" "}</Typography>
                        <LinearProgress />
                    </Card>
                    :
                    <Grid container>
                        {buildData.map(section => {
                            return (
                                <Grid
                                    container
                                    style={{ maxWidth: 'calc(50% - 0.5em)', backgroundColor: 'rgb(238, 238, 238)', margin: '0.25em' }}
                                    key={`section_${section.key}`}
                                    id={`section_${section.key}`}>
                                    <div style={{ padding: '0.5em' }}>
                                        <Typography align="center" variant="title">
                                            {section.title}
                                        </Typography>
                                    </div>
                                    <div style={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "0px 0.6rem 0.6rem 0px"
                                    }}>
                                        <div id={`graphic_${section.key}`} style={{
                                            width: "70%",
                                            display: "inline"
                                        }}>
                                            <SimpleBarChart
                                                data={section.data}
                                                dataKeyX={section.labelName}
                                                dataKeyY={"personas"}
                                                typeX={"category"}
                                                typeY={"number"}
                                                vertical={section.graphicVertical}
                                                minHeight={350}
                                                barColor="#8884d8"
                                            />
                                        </div>
                                        <div id={`table_${section.key}`} style={{ width: '30%', display: 'inline', padding: '1.5em' }}>
                                            <Table id="tableAux">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ padding: '4px 0px 4px 4px' }}>País</TableCell>
                                                        <TableCell style={{ padding: '4px 0px 4px 4px', textAlign: 'right' }}>Visitantes</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {section.data.map(item => {
                                                        return (
                                                            <TableRow
                                                                style={{ height: '40px' }}
                                                                key={`${section.key}_${item[section.idKey]}`}>
                                                                <TableCell style={{ padding: '3px 0px 3px 2px' }}>
                                                                    {item[section.labelName]}
                                                                </TableCell>
                                                                <TableCell style={{ padding: '3px 0px 3px 2px', textAlign: 'right' }}>
                                                                    {item.personas}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                    <TableRow style={{ fontWeight: 'bold' }}>
                                                        <TableCell style={{ padding: '4px 0px 4px 4px' }}>Total</TableCell>
                                                        <TableCell style={{ padding: '4px 0px 4px 4px', textAlign: 'right' }}>
                                                            {section.total}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </div>
                                </Grid>
                            );
                        })}
                    </Grid>
                }
            </Fragment >
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    };
}

const mapStateToProps = state => ({
    main: state.main
});

const compare = (a,b) => {
    if (a.personas < b.personas)
      return -1;
    if (a.personas > b.personas)
      return 1;
    return 0;
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashBoardContainer);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardContainer.js